import React, { useEffect } from 'react';
import { useNavigation } from '../../routes/NavigationContext';
import OmniBot from './OmniBot/Main.js';
import LexBot from './LexBot/Main.js';
import GoogleBot from './GoogleBot/Main.js';
import GenesysBot from './GenesysBot/Main.js';
// import AWSConnectQBot from './AmazonConnectQ/QBot.js'; // Import Q Bot
import botConfig from '../../bot-config-map.json';

const DynamicBotLoader = () => {
  const { currentPath } = useNavigation();

  // Find the best matching config for the current path
  const findConfigForPage = (path) => {
    const keys = Object.keys(botConfig);

    // Sort by specificity: exact matches come first, then wildcards
    const matchingKey = keys
      .filter((key) => {
        if (key === path) {
          return true; // Exact match
        }
        if (key.endsWith('/*')) {
          const basePath = key.replace('/*', '');
          return path.startsWith(basePath); // Match wildcards
        }
        return false;
      })
      .sort((a, b) => b.length - a.length)[0]; // Prioritize more specific matches

    // Combine exact match and wildcard into one config
    if (matchingKey && matchingKey.endsWith('/*')) {
      const basePath = matchingKey.replace('/*', '');
      if (keys.includes(basePath)) {
        // Example: If `/services/*` and `/services` both exist, merge `/services` into `/services/*`
        return { ...botConfig[basePath], ...botConfig[matchingKey] };
      }
    }

    return botConfig[matchingKey] || botConfig['/'];
  };

  const configForPage = findConfigForPage(currentPath);

  useEffect(() => {
    console.log(`Route changed to: ${currentPath}`);
  }, [currentPath]);

  if (!configForPage?.type) return null;

  return (
    <div className="chat-widget-container" key={currentPath}>
      {(() => {
        switch (configForPage.type) {
          case 'omnibot':
            return <OmniBot key={`omnibot-${currentPath}`} config={configForPage} />;
          case 'aws-lex':
            return <LexBot key={`aws-lex-${currentPath}`} config={configForPage} />;
          case 'google-dialogflow':
            return <GoogleBot key={`google-dialogflow-${currentPath}`} config={configForPage} />;
          case 'genesys':
            return <GenesysBot key={`genesys-${currentPath}`} config={configForPage} />;
          // case 'aws-connectq': // Add the Q Bot case
            // return <AWSConnectQBot key={`aws-connectq-${currentPath}`} config={configForPage} />;
          default:
            return null;
        }
      })()}
    </div>
  );
};

export default DynamicBotLoader;
